import { Alert } from "@mui/material";
export default function ({ message = "Something broke!", severity = "error" }) {
  return (
    <Alert style={{ whiteSpace: "pre-line" }}  severity={severity}>
      {message}
    </Alert>
  );
}
